/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy tools built on real scoring data`)
};

const es_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas de F1 Fantasy basadas en datos reales de puntuación`)
};

const de_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1-Fantasy-Werkzeuge, gebaut auf echten Wertungsdaten`)
};

const nl_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy-tools gebouwd op echte scoregegevens`)
};

const fr_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des outils F1 Fantasy construits sur de vraies données de scoring`)
};

const it_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti F1 Fantasy basati su dati di punteggio reali`)
};

const pt_br2_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de F1 Fantasy construídas sobre dados reais de pontuação`)
};

const pt_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de F1 Fantasy construídas sobre dados reais de pontuação`)
};

const ja_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実際の得点データに基づいて作られたF1ファンタジーツール`)
};

const zh_f1_seo_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基于真实得分数据打造的 F1 Fantasy 工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_seo_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_seo_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_seo_title", locale)
	if (locale === "en") return en_f1_seo_title(inputs)
	if (locale === "es") return es_f1_seo_title(inputs)
	if (locale === "de") return de_f1_seo_title(inputs)
	if (locale === "nl") return nl_f1_seo_title(inputs)
	if (locale === "fr") return fr_f1_seo_title(inputs)
	if (locale === "it") return it_f1_seo_title(inputs)
	if (locale === "pt-BR") return pt_br2_f1_seo_title(inputs)
	if (locale === "pt") return pt_f1_seo_title(inputs)
	if (locale === "ja") return ja_f1_seo_title(inputs)
	return zh_f1_seo_title(inputs)
};